import breakpoints from '@assets/theme/breakpoints';
import palette from '@assets/theme/palette';
import { customShadows } from '@assets/theme/shadows';
import { Popover, styled } from '@mui/material';

const CalculationsMenuStyledContainer = styled('div')`
  display: flex;
  align-items: center;

  .calculations-menu__trigger {
    font-size: 14px;
    font-family: inherit;
    line-height: inherit;
    vertical-align: baseline;
    color: ${palette.light.blue[400]};
    border-bottom: 1px solid transparent;
    transition: 400ms;

    &:hover {
      color: #224179;
      border-bottom: 1px solid ${palette.light.blue[400]};
    }
  }
`;

export const CalculationsControlsStyled = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px 30px;

  .control {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    align-items: center;
    margin-left: auto;

    &:empty {
      display: none;
    }
  }

  .control__buttons {
    position: relative;
    display: flex;
    align-items: center;
  }

  .copy-success-alert {
    position: absolute;
    right: 0;
    bottom: 30px;
    display: flex;
    align-items: center;

    .MuiAlert-message {
      white-space: nowrap;
    }
  }
`;

export const CalculationsMenuPopoverStyled = styled(Popover)`
  .MuiPopover-paper {
    width: min(720px, calc(100vw - 32px));
    max-width: calc(100vw - 32px);
    max-height: calc(100vh - 32px);
    max-height: calc(100dvh - 32px);
    margin-top: 8px;
    border-radius: 18px;
    box-shadow: ${customShadows.light.z20};
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .calculations-menu__header {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${palette.light.grey[200]};
  }

  .calculations-menu__close {
    margin-right: 8px;
    color: ${palette.light.grey[700]};

    svg {
      font-size: 22px;
    }
  }

  .calculations-menu__tabs {
    flex: 1;
    min-width: 0;
    padding: 0 12px;

    .MuiTab-root {
      text-transform: none;
      font-size: 14px;
      font-weight: 600;
    }
  }

  .calculations-menu__list {
    max-height: 420px;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .calculations-menu__item {
    width: 100%;
    text-align: left;
    padding: 16px 24px;
    border-bottom: 1px solid ${palette.light.grey[200]};

    &:last-child {
      border-bottom: none;
    }

    &-content {
      min-width: 0;
    }
  }

  .calculations-menu__item .a-service-basket {
    grid-template-columns: minmax(0, 1fr);

    .a-service-basket-fields {
      grid-column: 1;
    }
  }

  .calculations-menu__actions {
    display: flex;
    gap: 4px;

    .MuiIconButton-root {
      width: 32px;
      height: 32px;
      color: ${palette.light.grey[700]};
      transition: color 200ms ease;

      &:hover {
        color: ${palette.light.blue[400]};
      }
    }

    svg {
      font-size: 22px;
    }

    .calculations-menu__accent-button {
      border: 1px solid ${palette.light.blue[400]};
      border-radius: 50%;
      color: ${palette.light.blue[400]};
      transition: color 200ms ease, background-color 200ms ease;

      svg {
        font-size: 20px;
        color: inherit;
      }

      &:hover {
        background-color: ${palette.light.blue[400]};
        color: ${palette.light.common.white};
      }

      &:hover svg {
        color: ${palette.light.common.white};
      }
    }

    .calculations-menu__accent-button .calculations-menu__favorite-icon {
      font-size: 24px;

      path {
        fill: currentColor;
        stroke: currentColor;
      }
    }
  }

  .calculations-menu__item--history {
    position: relative;

    > .calculations-menu__actions {
      position: absolute;
      top: 16px;
      right: 24px;
    }

    .order-product-component .MuiTypography-h4 {
      padding-right: 48px;
    }

    .a-service-basket .caption {
      padding-right: 48px;
    }

    .order-product-component {
      display: grid;
      gap: 4px;

      .MuiTypography-h4 {
        font-size: 16px;
        font-weight: 500;
        line-height: inherit;
        letter-spacing: inherit;
        color: rgba(0, 0, 0, 1);
      }

      .route-history-cargo {
        font-size: 14px;
        font-weight: 400;
        color: ${palette.light.grey[300]};
      }
    }
  }

  .calculations-menu__status {
    min-height: 72px;
    padding: 24px;
    display: flex;
    align-items: center;
    box-sizing: border-box;

    .MuiLinearProgress-root {
      width: 100%;
    }

    .MuiTypography-root {
      font-size: 14px;
      color: ${palette.light.grey[300]};
    }
  }

  .calculations-menu__footer {
    flex-shrink: 0;
    border-top: 1px solid ${palette.light.grey[200]};
    padding: 14px 24px;
    font-size: 14px;
    font-weight: 600;
  }

  @media (max-width: ${breakpoints.values.sm}px) {
    .MuiBackdrop-root.MuiBackdrop-invisible {
      background-color: rgba(0, 0, 0, 0.4);
    }

    .calculations-menu__list {
      max-height: none;
    }

    .MuiPopover-paper {
      top: auto !important;
      bottom: 0;
      left: 0 !important;
      right: 0;
      width: 100%;
      max-width: 100%;
      margin-top: 0;
      border-radius: 18px 18px 0 0;
      transform-origin: center bottom !important;
    }

    .calculations-menu__item {
      padding: 12px 16px;
    }

    .calculations-menu__item--history > .calculations-menu__actions {
      top: 12px;
      right: 16px;
    }

    .calculations-menu__status {
      padding: 16px;
    }

    .calculations-menu__footer {
      padding: 12px 16px;
      font-size: 13px;
    }

    .calculations-menu__tabs .MuiTab-root {
      font-size: 13px;
    }

    .calculations-menu__item .order-product-component .MuiTypography-h4 {
      font-size: 14px;
    }

    .calculations-menu__item .a-service-basket .caption {
      font-size: 14px;
    }

    .calculations-menu__item .order-product-component .route-history-cargo {
      font-size: 12px;
    }

    .calculations-menu__item .order-product-component .cargo {
      font-size: 12px;
    }

    .calculations-menu__item .a-service-basket .properties {
      font-size: 12px;
    }

    .calculations-menu__item .a-service-basket-fields .list {
      font-size: 12px;
    }
  }
`;

export default CalculationsMenuStyledContainer;
